import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const Notifications = () => import('./views/Index.vue');

export default [
  {
    path: '/notifications',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'Notifications',
        component: Notifications,
        meta: { title: i18n.global.t('main.notifications') },
      },
    ],
  },
];
